// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dwmnI","title":"styles_title__sN5vi"};